import styled from '../../helpers/styled';

export const RecipeScreen = styled.div`
   background-color: black;
`;

export const RecipeBanner = styled.img`
    width: 100%;
`;
